// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {Tag, Tooltip, message} from "antd";
import {QuestionCircleTwoTone} from "@ant-design/icons";
import React from "react";
import {isMobile as isMobileDevice} from "react-device-detect";
import "./i18n";
import i18next from "i18next";
import copy from "copy-to-clipboard";
import {authConfig} from "./Auth";
import {Helmet} from "react-helmet";
import * as Conf from "./Conf";
// import moment from "moment";

export const ServerUrl = "";

// export const StaticBaseUrl = "https://cdn.jsdelivr.net/gh/casbin/static";
export const StaticBaseUrl = "https://cdn.casbin.org";

// https://catamphetamine.gitlab.io/country-flag-icons/3x2/index.html
export const CountryRegionData = getCountryRegionData();

export const AdminOrganization = "built-in"; // 管理员组织name

export const AdminApplication = "app-built-in"; // 管理员应用

export const Admin = "admin"; // 超管

export const DefaultProvider = "provider_captcha_default"; // 默认的身份源

export const OtherProviderInfo = {
  SMS: {
    "Aliyun SMS": {
      logo: require("../assets/images/provider/icon/social_aliyun.png"),
      url: "https://aliyun.com/product/sms",
    },
    "Tencent Cloud SMS": {
      logo: require("../assets/images/provider/icon/social_tencent_cloud.jpg"),
      url: "https://cloud.tencent.com/product/sms",
    },
    "Volc Engine SMS": {
      logo: `${StaticBaseUrl}/img/social_volc_engine.jpg`,
      url: "https://www.volcengine.com/products/cloud-sms",
    },
    "Huawei Cloud SMS": {
      logo: `${StaticBaseUrl}/img/social_huawei.png`,
      url: "https://www.huaweicloud.com/product/msgsms.html",
    },
    "Twilio SMS": {
      logo: `${StaticBaseUrl}/img/social_twilio.png`,
      url: "https://www.twilio.com/messaging",
    },
    "SmsBao SMS": {
      logo: `${StaticBaseUrl}/img/social_smsbao.png`,
      url: "https://www.smsbao.com/",
    },
    "Mock SMS": {
      logo: `${StaticBaseUrl}/img/social_default.png`,
      url: "",
    },
  },
  Email: {
    "Default Email": {
      logo: require("../assets/images/provider/icon/email_default.png"),
      url: "",
    },
  },
  Storage: {
    "Local File System": {
      logo: require("../assets/images/provider/icon/social_file.png"),
      url: "",
    },
    "AWS S3": {
      logo: `${StaticBaseUrl}/img/social_aws.png`,
      url: "https://aws.amazon.com/s3",
    },
    "MinIO": {
      logo: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNjIuNjEyIDI0LjQ2NSIgeG1sbnM6dj0iaHR0cHM6Ly92ZWN0YS5pby9uYW5vIj48cGF0aCBkPSJNNTIuNzUxLjQxNGg5LjEwOHYyMy42M2gtOS4xMDh6TTQxLjcxMS43NGwtMTguNDg4IDkuOTJhLjkxOS45MTkgMCAwIDEtLjg1NiAwTDMuODc5Ljc0QTIuODA4IDIuODA4IDAgMCAwIDIuNTU4LjQxNGgtLjAyM0EyLjQgMi40IDAgMCAwIDAgMi42NDF2MjEuMzc2aDkuMVYxMy44NDJhLjkxOC45MTggMCAwIDEgMS4zODUtLjY4MmwxMC4zNjEgNS41NjhhMy42MzQgMy42MzQgMCAwIDAgMy4zMzYuMDI4bDEwLjkzMy01LjYzNGEuOTE3LjkxNyAwIDAgMSAxLjM3MS42OXYxMC4yMDVoOS4xVjIuNjQxQTIuNCAyLjQgMCAwIDAgNDMuMDU1LjQxNGgtLjAyM2EyLjgwOCAyLjgwOCAwIDAgMC0xLjMyMS4zMjZ6bTY1LjU2NC0uMzI2aC05LjIzN3YxMC43NTVhLjkxMy45MTMgMCAwIDEtMS4zMzguNzA2TDcyLjc2Mi42NzVhMi44MjQgMi44MjQgMCAwIDAtMS4xOTEtLjI2MWgtLjAxNmEyLjQgMi40IDAgMCAwLTIuNTM1IDIuMjI3djIxLjM3N2g5LjE2M1YxMy4yNzVhLjkxNC45MTQgMCAwIDEgMS4zMzctLjcwN2wyNC4wMzIgMTEuMmEyLjgxMyAyLjgxMyAwIDAgMCAxLjE4OC4yNiAyLjQgMi40IDAgMCAwIDIuNTM1LTIuMjI3em03LjE2MSAyMy42M1YuNDE0aDQuMTkxdjIzLjYzem0yOC44NTYuNDIxYy0xMS4yNzQgMC0xOS4yNzItNC43LTE5LjI3Mi0xMi4yMzJDMTI0LjAyIDQuNzQxIDEzMi4wNjYgMCAxNDMuMjkyIDBzMTkuMzIgNC43IDE5LjMyIDEyLjIzMy03LjkwMiAxMi4yMzItMTkuMzIgMTIuMjMyem0wLTIxLjMzM2MtOC4zODMgMC0xNC44NCAzLjIxNy0xNC44NCA5LjEgMCA1LjkyNiA2LjQ1NyA5LjEgMTQuODQgOS4xczE0Ljg4Ny0zLjE3NCAxNC44ODctOS4xYzAtNS44ODMtNi41MDQtOS4xLTE0Ljg4Ny05LjF6IiBmaWxsPSIjYzcyYzQ4Ii8+PC9zdmc+",
      url: "https://min.io/",
    },
    "Aliyun OSS": {
      logo: `${StaticBaseUrl}/img/social_aliyun.png`,
      url: "https://aliyun.com/product/oss",
    },
    "Tencent Cloud COS": {
      logo: `${StaticBaseUrl}/img/social_tencent_cloud.jpg`,
      url: "https://cloud.tencent.com/product/cos",
    },
    "Azure Blob": {
      logo: `${StaticBaseUrl}/img/social_azure.png`,
      url: "https://azure.microsoft.com/en-us/services/storage/blobs/",
    },
  },
  SAML: {
    "Aliyun IDaaS": {
      logo: `${StaticBaseUrl}/img/social_aliyun.png`,
      url: "https://aliyun.com/product/idaas",
    },
    "Keycloak": {
      logo: `${StaticBaseUrl}/img/social_keycloak.png`,
      url: "https://www.keycloak.org/",
    },
  },
  Payment: {
    "Alipay": {
      logo: `${StaticBaseUrl}/img/payment_alipay.png`,
      url: "https://www.alipay.com/",
    },
    "WeChat Pay": {
      logo: `${StaticBaseUrl}/img/payment_wechat_pay.png`,
      url: "https://pay.weixin.qq.com/",
    },
    "PayPal": {
      logo: `${StaticBaseUrl}/img/payment_paypal.png`,
      url: "https://www.paypal.com/",
    },
    "GC": {
      logo: `${StaticBaseUrl}/img/payment_gc.png`,
      url: "https://gc.org",
    },
  },
  Captcha: {
    "Default Captcha": {
      logo: require("../assets/images/provider/icon/captcha_default.png"),
      url: "https://pkg.go.dev/github.com/dchest/captcha",
    },
    "reCAPTCHA": {
      logo: `${StaticBaseUrl}/img/social_recaptcha.png`,
      url: "https://www.google.com/recaptcha",
    },
    "hCaptcha": {
      logo: `${StaticBaseUrl}/img/social_hcaptcha.png`,
      url: "https://www.hcaptcha.com",
    },
    "Aliyun Captcha": {
      logo: `${StaticBaseUrl}/img/social_aliyun.png`,
      url: "https://help.aliyun.com/product/28308.html",
    },
    "GEETEST": {
      logo: `${StaticBaseUrl}/img/social_geetest.png`,
      url: "https://www.geetest.com",
    },
  },
};

export const passwordComplexity = [
  {label: i18next.t("password:Number letter"), value: "number_letter"},
  {label: i18next.t("password:Special letter"), value: "special_letter"},
  {label: i18next.t("password:Upper letter"), value: "upper_letter"},
  {label: i18next.t("password:Lower letter"), value: "lower_letter"},
];

// 上游同步类型
export const upstreamSyncTypes = [
  {id: 0, name: i18next.t("syncer:User sync")},
  {id: 1, name: i18next.t("syncer:Department sync")},
  {id: 2, name: i18next.t("syncer:Relationship sync")},
];

export const upstreamSyncTypesTooltip = [
  {id: 0, name: i18next.t("syncer:User sync - Tooltip")},
  {id: 1, name: i18next.t("syncer:Department sync - Tooltip")},
  {id: 2, name: i18next.t("syncer:Relationship sync - Tooltip")},
];

// 下游同步类型
export const downstreamSyncTypes = [
  {id: 0, name: i18next.t("syncer:User sync")},
  {id: 1, name: i18next.t("syncer:Department sync")},
  {id: 2, name: i18next.t("syncer:Relationship sync")},
  {id: 3, name: i18next.t("syncer:Role sync")},
];

export const downstreamSyncTypesTooltip = [
  {id: 0, name: i18next.t("syncer:User sync - Tooltip")},
  {id: 1, name: i18next.t("syncer:Department sync - Tooltip")},
  {id: 2, name: i18next.t("syncer:Relationship sync - Tooltip")},
  {id: 3, name: i18next.t("syncer:Role sync - Tooltip")},
];

export function getCountryRegionData() {
  let language = i18next.language;
  if (language === null || language === "null") {
    language = Conf.DefaultLanguage;
  }

  const countries = require("i18n-iso-countries");
  countries.registerLocale(require("i18n-iso-countries/langs/" + language + ".json"));
  const data = countries.getNames(language, {select: "official"});
  const result = [];
  for (const i in data) {result.push({code: i, name: data[i]});}
  return result;
}

export function initServerUrl() {
  // const hostname = window.location.hostname;
  // if (hostname === "localhost") {
  //   ServerUrl = `http://${hostname}:8000`;
  // }
}

export function isLocalhost() {
  const hostname = window.location.hostname;
  return hostname === "localhost";
}

export function getFullServerUrl() {
  let fullServerUrl = window.location.origin;
  if (fullServerUrl === "http://localhost:7001") {
    fullServerUrl = "http://localhost:8000";
  }
  return fullServerUrl;
}

export function isProviderVisible(providerItem) {
  if (providerItem.provider === undefined || providerItem.provider === null) {
    return false;
  }

  if (providerItem.provider.category !== "OAuth" && providerItem.provider.category !== "SAML") {
    return false;
  }

  if (providerItem.provider.type === "WeChatMiniProgram") {
    return false;
  }

  return true;
}

export function isProviderVisibleForSignUp(providerItem) {
  if (providerItem.canSignUp === false) {
    return false;
  }

  return isProviderVisible(providerItem);
}

export function isProviderVisibleForSignIn(providerItem) {
  if (providerItem.canSignIn === false) {
    return false;
  }

  return isProviderVisible(providerItem);
}

export function isProviderPrompted(providerItem) {
  return isProviderVisible(providerItem) && providerItem.prompted;
}

export function isSignupItemPrompted(signupItem) {
  return signupItem.visible && signupItem.prompted;
}

export function getAllPromptedProviderItems(application) {
  return application.providers.filter(providerItem => isProviderPrompted(providerItem));
}

export function getAllPromptedSignupItems(application) {
  return application.signupItems.filter(signupItem => isSignupItemPrompted(signupItem));
}

export function getSignupItem(application, itemName) {
  const signupItems = application.signupItems?.filter(signupItem => signupItem.name === itemName);
  if (signupItems.length === 0) {
    return null;
  }
  return signupItems[0];
}

export function isValidPersonName(personName) {
  return personName !== "";

  // // https://blog.css8.cn/post/14210975.html
  // const personNameRegex = /^[\u4e00-\u9fa5]{2,6}$/;
  // return personNameRegex.test(personName);
}

export function isValidIdCard(idCard) {
  const idCardRegex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$/;
  return idCardRegex.test(idCard);
}

export function isValidEmail(email) {
  // https://github.com/yiminghe/async-validator/blob/057b0b047f88fac65457bae691d6cb7c6fe48ce1/src/rule/type.ts#L9
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email);
}

export function isValidPhone(phone) {
  if (phone === "") {
    return false;
  }

  // https://learnku.com/articles/31543, `^s*$` filter empty email individually.
  const phoneRegex = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
  return phoneRegex.test(phone);
}

export function isValidInvoiceTitle(invoiceTitle) {
  if (invoiceTitle === "") {
    return false;
  }

  // https://blog.css8.cn/post/14210975.html
  const invoiceTitleRegex = /^[()（）\u4e00-\u9fa5]{0,50}$/;
  return invoiceTitleRegex.test(invoiceTitle);
}

export function isValidTaxId(taxId) {
  // https://www.codetd.com/article/8592083
  const regArr = [/^[\da-z]{10,15}$/i, /^\d{6}[\da-z]{10,12}$/i, /^[a-z]\d{6}[\da-z]{9,11}$/i, /^[a-z]{2}\d{6}[\da-z]{8,10}$/i, /^\d{14}[\dx][\da-z]{4,5}$/i, /^\d{17}[\dx][\da-z]{1,2}$/i, /^[a-z]\d{14}[\dx][\da-z]{3,4}$/i, /^[a-z]\d{17}[\dx][\da-z]{0,1}$/i, /^[\d]{6}[\da-z]{13,14}$/i];
  for (let i = 0; i < regArr.length; i++) {
    if (regArr[i].test(taxId)) {
      return true;
    }
  }
  return false;
}

export function isAffiliationPrompted(application) {
  const signupItem = getSignupItem(application, "Affiliation");
  if (signupItem === null) {
    return false;
  }

  return signupItem.prompted;
}

export function hasPromptPage(application) {
  const providerItems = getAllPromptedProviderItems(application);
  if (providerItems.length !== 0) {
    return true;
  }

  const signupItems = getAllPromptedSignupItems(application);
  if (signupItems.length !== 0) {
    return true;
  }

  return isAffiliationPrompted(application);
}

function isAffiliationAnswered(user, application) {
  if (!isAffiliationPrompted(application)) {
    return true;
  }

  if (user === null) {
    return false;
  }
  return user.affiliation !== "";
}

function isProviderItemAnswered(user, application, providerItem) {
  if (user === null) {
    return false;
  }

  const provider = providerItem.provider;
  const linkedValue = user[provider.type.toLowerCase()];
  return linkedValue !== undefined && linkedValue !== "";
}

function isSignupItemAnswered(user, signupItem) {
  if (user === null) {
    return false;
  }

  if (signupItem.name !== "Country/Region") {
    return true;
  }

  const value = user["region"];
  return value !== undefined && value !== "";
}

export function isPromptAnswered(user, application) {
  if (!isAffiliationAnswered(user, application)) {
    return false;
  }

  const providerItems = getAllPromptedProviderItems(application);
  for (let i = 0; i < providerItems.length; i++) {
    if (!isProviderItemAnswered(user, application, providerItems[i])) {
      return false;
    }
  }

  const signupItems = getAllPromptedSignupItems(application);
  for (let i = 0; i < signupItems.length; i++) {
    if (!isSignupItemAnswered(user, signupItems[i])) {
      return false;
    }
  }
  return true;
}

export function parseObject(s) {
  try {
    return eval("(" + s + ")");
  } catch (e) {
    return null;
  }
}

export function parseJson(s) {
  if (s === "") {
    return null;
  } else {
    return JSON.parse(s);
  }
}

export function myParseInt(i) {
  const res = parseInt(i);
  return isNaN(res) ? 0 : res;
}

export function openLink(link) {
  // this.props.history.push(link);
  const w = window.open("about:blank");
  w.location.href = link;
}

export function openLinkSafe(link) {
  // Javascript window.open issue in safari
  // https://stackoverflow.com/questions/45569893/javascript-window-open-issue-in-safari
  const a = document.createElement("a");
  a.href = link;
  a.setAttribute("target", "_blank");
  a.click();
}

export function goToLink(link) {
  window.location.href = link;
}

export function goToLinkSoft(ths, link, from) {
  if (link.startsWith("http")) {
    openLink(link);
    return;
  }

  ths.props.history.push({pathname: link, state: {
    prevPath: from,
  }});
}

export function showMessage(type, text) {
  if (type === "") {
    return;
  } else if (type === "success") {
    message.success(text);
  } else if (type === "error") {
    message.error(text);
  } else if (type === "info") {
    message.info(text);
  }
}

export function getResponseMessage(msg) {
  if (typeof msg !== "string") {
    return msg;
  }
  const reg = /\{(.+?)\}/g;
  const array = msg.match(reg);
  if (array === null || array === undefined) {
    return i18next.t(`ErrMsg:${msg}`);
  }
  let text = msg;
  const params = [];
  array.map((str, index) => {
    text = text.replace(str, `{param${index}}`);
    params.push(str.replace("{", "").replace("}", ""));
  });
  let output = i18next.t(`ErrMsg:${text}`);
  params.map((str, index) => {
    output = output.replace(`{param${index}}`, str);
  });
  return output;
}

export function showResponseMessage(msg) {
  const output = getResponseMessage(msg);
  message.error(output);

}

// 管理员（超管和普通管理员）
export function isAdminUser(account) {
  if (account === undefined || account === null) {
    return false;
  }
  // return account.owner === "built-in" || account.isGlobalAdmin === true;
  return account.isAdmin === true;
}

// 超管
export function isSuperAdminUser(account) {
  if (account === undefined || account === null) {
    return false;
  }
  return account.isGlobalAdmin === true;
}

export function isLocalAdminUser(account) {
  if (account === undefined || account === null) {
    return false;
  }
  return account.isAdmin === true || isAdminUser(account);
}

export function deepCopy(obj) {
  return Object.assign({}, obj);
}

export function addRow(array, row) {
  return [...array, row];
}

export function prependRow(array, row) {
  return [row, ...array];
}

export function deleteRow(array, i) {
  // return array = array.slice(0, i).concat(array.slice(i + 1));
  return [...array.slice(0, i), ...array.slice(i + 1)];
}

export function swapRow(array, i, j) {
  return [...array.slice(0, i), array[j], ...array.slice(i + 1, j), array[i], ...array.slice(j + 1)];
}

export function trim(str, ch) {
  if (str === undefined) {
    return undefined;
  }

  let start = 0;
  let end = str.length;

  while (start < end && str[start] === ch) {++start;}

  while (end > start && str[end - 1] === ch) {--end;}

  return (start > 0 || end < str.length) ? str.substring(start, end) : str;
}

export function isMobile() {
  // return getIsMobileView();
  return isMobileDevice;
}

export function getFormattedDate(date) {
  if (date === undefined) {
    return null;
  }

  date = date.replace("T", " ");
  date = date.replace("+08:00", " ");
  return date;
}

export function getFormattedDateShort(date) {
  return date.slice(0, 10);
}

export function getShortName(s) {
  return s.split("/").slice(-1)[0];
}

export function getShortText(s, maxLength = 35) {
  if (s.length > maxLength) {
    return `${s.slice(0, maxLength)}...`;
  } else {
    return s;
  }
}

export function getFriendlyFileSize(size) {
  if (size < 1024) {
    return size + " B";
  }

  const i = Math.floor(Math.log(size) / Math.log(1024));
  let num = (size / Math.pow(1024, i));
  const round = Math.round(num);
  num = round < 10 ? num.toFixed(2) : round < 100 ? num.toFixed(1) : round;
  return `${num} ${"KMGTPEZY"[i - 1]}B`;
}

function getHashInt(s) {
  let hash = 0;
  if (s.length !== 0) {
    for (let i = 0; i < s.length; i++) {
      const char = s.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }
  }

  if (hash < 0) {
    hash = -hash;
  }
  return hash;
}

export function getAvatarColor(s) {
  const colorList = ["#f56a00", "#7265e6", "#ffbf00", "#00a2ae"];
  const hash = getHashInt(s);
  return colorList[hash % 4];
}

export function getLanguage() {
  return i18next.language;
}

export function setLanguage(language) {
  localStorage.setItem("language", language);
  changeMomentLanguage(language);
  i18next.changeLanguage(language);
}

export function changeLanguage(language) {
  localStorage.setItem("language", language);
  changeMomentLanguage(language);
  i18next.changeLanguage(language);
  window.location.reload(true);
}

export function changeMomentLanguage(language) {
  // if (language === "zh") {
  //   moment.locale("zh-cn");
  // } else {
  //   moment.locale("en_GB");
  // }
}

export function getClickable(text) {
  return (
    <a onClick={() => {
      copy(text);
      showMessage("success", "Copied to clipboard");
    }}>
      {text}
    </a>
  );
}

export function getProviderLogoURL(provider) {
  if (provider.category === "OAuth") {
    if (provider.type === "Custom") {
      return provider.customLogo;
    }
    if (provider.type === "WeChat" || provider.type === "WeCom") {
      return require(`../assets/images/provider/icon/social_${provider.type.toLowerCase()}.png`);
    }
  } else {
    const info = OtherProviderInfo[provider.category][provider.type];
    // avoid crash when provider is not found
    if (info) {
      return info.logo;
    }
    return "";
  }
}

export function getProviderLogo(provider) {
  const idp = provider.type.toLowerCase().trim().split(" ")[0];
  const url = getProviderLogoURL(provider);
  return (
    <img width={30} height={30} src={url} alt={idp} />
  );
}

export function getProviderTypeOptions(category) {
  if (category === "OAuth") {
    return (
      [
        // {id: "Google", name: "Google"},
        // {id: "GitHub", name: "GitHub"},
        // {id: "QQ", name: "QQ"},
        {id: "WeChat", name: "WeChat"},
        // {id: "WeChatMiniProgram", name: "WeChat Mini Program"},
        // {id: "Facebook", name: "Facebook"},
        // {id: "DingTalk", name: "DingTalk"},
        // {id: "Weibo", name: "Weibo"},
        // {id: "Gitee", name: "Gitee"},
        // {id: "LinkedIn", name: "LinkedIn"},
        {id: "WeCom", name: "WeCom"},
        // {id: "Lark", name: "Lark"},
        // {id: "GitLab", name: "GitLab"},
        // {id: "Adfs", name: "Adfs"},
        // {id: "Baidu", name: "Baidu"},
        // {id: "Alipay", name: "Alipay"},
        // {id: "Casdoor", name: "Casdoor"},
        // {id: "Infoflow", name: "Infoflow"},
        // {id: "Apple", name: "Apple"},
        // {id: "AzureAD", name: "AzureAD"},
        // {id: "Slack", name: "Slack"},
        // {id: "Steam", name: "Steam"},
        // {id: "Bilibili", name: "Bilibili"},
        // {id: "Okta", name: "Okta"},
        // {id: "Douyin", name: "Douyin"},
        // {id: "Custom", name: "Custom"},
      ]
    );
  } else if (category === "Email") {
    return (
      [
        {id: "Default Email", name: "Default Email"},
        // {id: "SUBMAIL", name: "SUBMAIL"},
      ]
    );
  } else if (category === "SMS") {
    return (
      [
        {id: "Aliyun SMS", name: "Aliyun SMS"},
        {id: "Tencent Cloud SMS", name: "Tencent Cloud SMS"},
        // {id: "Volc Engine SMS", name: "Volc Engine SMS"},
        // {id: "Huawei Cloud SMS", name: "Huawei Cloud SMS"},
        // {id: "Twilio SMS", name: "Twilio SMS"},
        // {id: "SmsBao SMS", name: "SmsBao SMS"},
      ]
    );
  } else if (category === "Storage") {
    return (
      [
        {id: "Local File System", name: "Local File System"},
        // {id: "AWS S3", name: "AWS S3"},
        {id: "MinIO", name: "MinIO"},
        // {id: "Aliyun OSS", name: "Aliyun OSS"},
        // {id: "Tencent Cloud COS", name: "Tencent Cloud COS"},
        // {id: "Azure Blob", name: "Azure Blob"},
      ]
    );
  } else if (category === "SAML") {
    return ([
      {id: "Aliyun IDaaS", name: "Aliyun IDaaS"},
      {id: "Keycloak", name: "Keycloak"},
    ]);
  } else if (category === "Payment") {
    return ([
      {id: "Alipay", name: "Alipay"},
      {id: "WeChat Pay", name: "WeChat Pay"},
      {id: "PayPal", name: "PayPal"},
      {id: "GC", name: "GC"},
    ]);
  } else if (category === "Captcha") {
    return ([
      {id: "Default Captcha", name: "Default Captcha"},
      // {id: "reCAPTCHA", name: "reCAPTCHA"},
      // {id: "hCaptcha", name: "hCaptcha"},
      // {id: "Aliyun Captcha", name: "Aliyun Captcha"},
      // {id: "GEETEST", name: "GEETEST"},
    ]);
  } else {
    return [];
  }
}

export function getProviderSubTypeOptions(type) {
  if (type === "WeCom") {
    return (
      [
        {id: "Internal", name: "Internal"},
        // {id: "Third-party", name: "Third-party"},
      ]
    );
  } else if (type === "Infoflow") {
    return (
      [
        {id: "Internal", name: "Internal"},
        {id: "Third-party", name: "Third-party"},
      ]
    );
  } else if (type === "Aliyun Captcha") {
    return [
      {id: "nc", name: "Sliding Validation"},
      {id: "ic", name: "Intelligent Validation"},
    ];
  } else {
    return [];
  }
}

export function renderLogo(application) {
  if (application === null) {
    return null;
  }

  if (application.homepageUrl !== "") {
    return (
      <a target="_blank" rel="noreferrer" href={application.homepageUrl}>
        {
          application.systemLogo === "" ?
            <img width={250} src={application.logo} alt={application.displayName} style={{marginBottom: "10px"}} />
            :
            <li className="icon-container" style={{width: 48, height: 48}}
            >
              <span className={["app-icon", application.sysLogoBg].join(" ")} style={{width: 40, height: 40, fontSize: 32}}></span>
            </li>
        }
      </a>
    );
  } else {
    return (
      <>
        {
          application.systemLogo === "" ?
            <img width={250} src={application.logo} alt={application.displayName} style={{marginBottom: "10px"}} />
            :
            <li className="icon-container" style={{width: 48, height: 48}}
            >
              <span className={["app-icon", application.sysLogoBg].join(" ")} style={{width: 40, height: 40, fontSize: 32}}></span>
            </li>
        }
      </>
    );
  }
}

export function goToLogin(ths, application) {
  if (application === null) {
    return;
  }

  if (!application.enablePassword && window.location.pathname.includes("/auto-signup/oauth/authorize")) {
    const link = window.location.href.replace("/auto-signup/oauth/authorize", "/login/oauth/authorize");
    goToLink(link);
    return;
  }

  if (authConfig.appName === application.uid) {
    goToLinkSoft(ths, "/login");
  } else {
    if (application.signinUrl === "") {
      goToLink(`${application.homepageUrl}/login`);
    } else {
      goToLink(application.signinUrl);
    }
  }
}

export function goToSignup(ths, application) {
  if (application === null) {
    return;
  }

  if (!application.enablePassword && window.location.pathname.includes("/login/oauth/authorize")) {
    const link = window.location.href.replace("/login/oauth/authorize", "/auto-signup/oauth/authorize");
    goToLink(link);
    return;
  }

  if (authConfig.appName === application.uid) {
    goToLinkSoft(ths, "/signup");
  } else {
    if (application.signupUrl === "") {
      goToLinkSoft(ths, `/signup/${application.uid}`);
    } else {
      goToLink(application.signupUrl);
    }
  }
}

export function goToForget(ths, application, query = "") {
  if (application === null) {
    return;
  }

  if (authConfig.appName === application.uid) {
    goToLinkSoft(ths, `/forget/${query}`);
  } else {
    if (application.forgetUrl === "") {
      goToLinkSoft(ths, `/forget/${application.uid}/${query}`);
    } else {
      goToLink(application.forgetUrl);
    }
  }
}

export function goToActivate(ths, application, query = "") {
  if (application === null) {
    return;
  }

  if (authConfig.appName === application.uid) {
    goToLinkSoft(ths, `/activate/${query}`);
  } else {
    goToLinkSoft(ths, `/activate/${application.uid}/${query}`);
  }
}

export function goToRemind(ths, organization) {
  if (organization === null) {
    return;
  }

  goToLink(`/password/remind/${organization.uid}`);
}

export function pushPasswordRemind(ths, organization) {
  if (organization === null) {
    return;
  }

  goToLinkSoft(ths, `/password/remind/${organization.uid}`);
}

export function renderHelmet(application) {
  if (application === undefined || application === null || application.organizationObj === undefined || application.organizationObj === null || application.organizationObj === "") {
    return null;
  }

  return (
    <Helmet>
      <title>{application.organizationObj.displayName}</title>
      {
        application.organizationObj.favicon ?
          <link rel="icon" href={application.organizationObj.favicon} />
          :
          <link rel="icon" href={require("../assets/images/default_icon.png")} />
      }
    </Helmet>
  );
}

export function getLabel(text, tooltip, necessary = false) {
  return (
    <React.Fragment>
      <span style={{marginRight: 4, position: "relative"}} className={necessary ? "necessary-field" : ""}>{text}</span>
      <Tooltip placement="top" title={tooltip}>
        <QuestionCircleTwoTone twoToneColor="rgb(45,120,213)" />
      </Tooltip>
    </React.Fragment>
  );
}

function repeat(str, len) {
  while (str.length < len) {
    str += str.substr(0, len - str.length);
  }
  return str;
}

function maskString(s) {
  if (s.length <= 2) {
    return s;
  } else {
    return `${s[0]}${repeat("*", s.length - 2)}${s[s.length - 1]}`;
  }
}

export function getMaskedPhone(s) {
  return s.replace(/(\d{3})\d*(\d{4})/, "$1****$2");
}

export function getMaskedEmail(email) {
  if (email === "") {return;}
  const tokens = email.split("@");
  let username = tokens[0];
  username = maskString(username);

  const domain = tokens[1];
  const domainTokens = domain.split(".");
  domainTokens[domainTokens.length - 2] = maskString(domainTokens[domainTokens.length - 2]);

  return `${username}@${domainTokens.join(".")}`;
}

export function getArrayItem(array, key, value) {
  const res = array.filter(item => item[key] === value)[0];
  return res;
}

export function getDeduplicatedArray(array, filterArray, key) {
  const res = array.filter(item => filterArray.filter(filterItem => filterItem[key] === item[key]).length === 0);
  return res;
}

export function getNewRowNameForTable(table, rowName) {
  const emptyCount = table.filter(row => row.name.includes(rowName)).length;
  let res = rowName;
  for (let i = 0; i < emptyCount; i++) {
    res = res + " ";
  }
  return res;
}

export function getNewRowIdForTable(table, rowUid) {
  const emptyCount = table.filter(row => row.uid.includes(rowUid)).length;
  let res = rowUid;
  for (let i = 0; i < emptyCount; i++) {
    res = res + " ";
  }
  return res;
}

export function getTagColor(s) {
  return "processing";
}

export function getTags(tags) {
  const res = [];
  if (!tags) {
    return res;
  }

  tags.forEach((tag, i) => {
    res.push(
      <Tag key={i} color={getTagColor(tag)}>
        {tag}
      </Tag>
    );
  });
  return res;
}

export function getTag(color, text) {
  return (
    <Tag color={color}>
      {text}
    </Tag>
  );
}

export function getApplicationOrgName(application) {
  return `${application?.organizationObj.owner}/${application?.organizationObj.uid}`;
}

export function getApplicationName(application) {
  return `${application?.owner}/${application?.uid}`;
}

export function getRandomName() {
  return Math.random().toString(36).slice(-6);
}

export function getRandomNumber() {
  return Math.random().toString(10).slice(-11);
}

export function getFromLink() {
  const from = sessionStorage.getItem("from");
  if (from === null) {
    return "/";
  }
  return from;
}

export function scrollToDiv(divId) {
  if (divId) {
    const ele = document.getElementById(divId);
    if (ele) {
      ele.scrollIntoView({behavior: "smooth"});
    }
  }
}

export function inIframe() {
  try {
    return window !== window.parent;
  } catch (e) {
    return true;
  }
}

export function getSyncerTableColumns(syncer) {
  switch (syncer.type) {
  case "Keycloak":
    return [
      {
        "name": "ID",
        "type": "string",
        "casdoorName": "Id",
        "isHashed": true,
        "values": [

        ],
      },
      {
        "name": "USERNAME",
        "type": "string",
        "casdoorName": "Name",
        "isHashed": true,
        "values": [

        ],
      },
      {
        "name": "LAST_NAME+FIRST_NAME",
        "type": "string",
        "casdoorName": "DisplayName",
        "isHashed": true,
        "values": [

        ],
      },
      {
        "name": "EMAIL",
        "type": "string",
        "casdoorName": "Email",
        "isHashed": true,
        "values": [

        ],
      },
      {
        "name": "EMAIL_VERIFIED",
        "type": "boolean",
        "casdoorName": "EmailVerified",
        "isHashed": true,
        "values": [

        ],
      },
      {
        "name": "FIRST_NAME",
        "type": "string",
        "casdoorName": "FirstName",
        "isHashed": true,
        "values": [

        ],
      },
      {
        "name": "LAST_NAME",
        "type": "string",
        "casdoorName": "LastName",
        "isHashed": true,
        "values": [

        ],
      },
      {
        "name": "CREATED_TIMESTAMP",
        "type": "string",
        "casdoorName": "CreatedTime",
        "isHashed": true,
        "values": [

        ],
      },
      {
        "name": "ENABLED",
        "type": "boolean",
        "casdoorName": "IsForbidden",
        "isHashed": true,
        "values": [

        ],
      },
    ];
  default:
    return [];
  }
}

// 获取上游同步的默认数据映射
export function getUpstreamSyncerTableColumns(syncType) {
  switch (syncType) {
  case "user":
    return [
      {name: "id", type: "string", localName: "Name", isHashed: true, isPermanent: true},
      {name: "name", type: "string", localName: "DisplayName", isHashed: false},
    ];
  case "department":
    return [
      {name: "code", type: "string", localName: "Code", isHashed: true, isPermanent: true},
    ];
  case "relationship":
    return [
      {name: "id", type: "string", localName: "Name", isHashed: true, isPermanent: true},
      {name: "code", type: "string", localName: "Code", isHashed: true, isPermanent: true},
    ];
  default:
    return [];
  }
}

export function isAdminOrganization(owner) {
  return owner === AdminOrganization;
}

export function checkInvalidInputChar(input) {
  for (let index = 0; index < input.length; index++) {
    switch (input.charCodeAt(index)) {
    case 34: // "
      return true;
    case 38: // &
      return true;
    case 39: // '
      return true;
    case 60: // <
      return true;
    case 62: // >
      return true;
    default:
      continue;
    }
  }
  return false;
}

export function getPasswordRuleText(passwordPolicy) {
  if (passwordPolicy === null) {
    return "";
  }

  const ruleText1 = i18next.t("password:Please make sure password length is at least {length}").replace("{length}", passwordPolicy.pwdLength);
  const rules = passwordPolicy.pwdComplexity.map(ruleItem => {
    const found = passwordComplexity.find(item => item.value === ruleItem);
    return found.label;
  }).join("、");
  const ruleText2 = i18next.t("password:And password must contain {text}").replace("{text}", rules);
  const ruleText3 = passwordPolicy.checkUserInfo ? i18next.t("password:Password should not include username、phone、email and name") : "";
  let output = ruleText1 + ruleText2 + ruleText3;
  if (output !== "") {
    output = output.substring(0, output.length - 1);
  }
  return output;
}

export function clearSession() {
  window.localStorage.removeItem("__APPLICATION__");

  window.sessionStorage.removeItem("__SKIP_PASSWORD_CHECK__");
}

// 账户激活配置的可选项

export const activationProcess = {
  userVerify: {
    labelText: i18next.t("activate:Information"),
    description: i18next.t("activationConfig:Verify user by name and username"),
  },
  WeChat: {
    labelText: i18next.t("activate:BindWeChat"),
    description: "",
  },
  WeCom: {
    labelText: i18next.t("activate:BindWeCom"),
    description: "",
  },
  email: {
    labelText: i18next.t("activate:BindEmail"),
    description: "",
  },
  phone: {
    labelText: i18next.t("activate:Phone"),
    description: "",
  },
  password: {
    labelText: i18next.t("activate:Password"),
    description: "",
  },
};

export const allActivationProcess = ["userVerify", "WeChat", "WeCom", "email", "phone", "password"];

// 护照判断
export function isValidPassport(idCard) {
  const idCardRegex = /^[a-zA-Z0-9]{5,17}$/;
  return idCardRegex.test(idCard);
}

// 港澳台居民居住证判断
export function isValidGATIDCard(idCard) {
  const idCardRegex = /^8[123]0000(?:19|20)\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{3}[\dX]$/;
  return idCardRegex.test(idCard);
}

// 港澳居民来往内地通行证判断
export function isValidGAPassport(idCard) {
  const idCardRegex = /^[H|h|M|m](\d{8}|\d{10})$/;
  return idCardRegex.test(idCard);
}

// 台湾居民来往大陆通行证判断
export function isValidTaiwanPassport(idCard) {
  const idCardRegex = /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/;
  return idCardRegex.test(idCard);
}
